import { Component } from '@angular/core';
import { clevertapPush, ModificationCommonService } from '../../services/modification-common.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';
import { IncomeProofBottomsheetComponent } from '../../components/income-proof-bottomsheet/income-proof-bottomsheet.component';
import { LoaderbotomsheetComponent } from '../../components/loaderbotomsheet/loaderbotomsheet.component';
import { MatDialog } from '@angular/material/dialog';
import { ProofCardComponent } from "../../components/proof-card/proof-card.component";
import { UtilService } from '../../services/util.service';
import { UserSessionService } from '../../services/user-session.service';
import { CommonService } from '../../services/common.service';
import { cardDetails, GetVendorURLReq } from '../../models/request.model';
import { ActivatedRoute } from '@angular/router';
import { UserSession } from '../../models/response.model';



@Component({
  selector: 'app-proof-selection',
  imports: [CommonModule, ProofCardComponent],
  templateUrl: './proof-selection.component.html',
  styleUrl: './proof-selection.component.less'
})
export class ProofSelectionComponent {
  btnLoader = false;
  dateRange: string = '';
  camsMode!: string;
  msgString!: string;
  card_data!: cardDetails[];
  selectedCardIndex: number | null = 1;
  selectcamsMode!: string
  UserSession!: UserSession
  isFinbox: boolean = false;
  casmMap = new Map<string, string>([
  ["1", 'CAMS_STOCK'],
  ["2", 'CAMS_STOCK'],
  ["3", 'CAMS_BANK'],
  ["4", 'CAMS_BANK'],
  ["5","FINBOX"]
  ])

  btnDisable = false;
  constructor(
    private modificationCommonService: ModificationCommonService,
    private matBottomSheet: MatBottomSheet,
    private dialog: MatDialog,
    private utilService: UtilService,
    private userSessionService: UserSessionService,
    private commonService: CommonService,
    private activeRouter : ActivatedRoute,
  ) {
     this.UserSession = this.userSessionService?.getUserSessionData();
    this.activeRouter.queryParams?.subscribe((params: any) => {
      if (params['finbox'] == "true") {
            this.camsMode = '5'
      } else {
        this.camsMode = params['camsMode'] || '';
      }
      sessionStorage.setItem("camsMode",this.camsMode)
    });
    this.selectcamsMode = this.camsMode;
  }
  ngOnInit(): void {
    this.updateDateRange();
    this.msgString = this.camsMode == '4' || this.camsMode == '5' ? `For this, we’ll fetch your last 6 months bank statement for duration between <b> ${this.dateRange} </b> from your primary bank account linked with 5paisa. This is a fully secure and consent-based process.` : this.camsMode == '1' ? `For this, we’ll fetch your latest Stock/ Mutual Fund holding as on ${this.dateRange} from your Depository. This is a fully secure and consent-based process.` : ''
    if (this.camsMode == '2' || this.camsMode == '3') {
      this.card_data = [{
    title: 'Fetch Stocks/ MF Holdings    ',
    isRecommeded: this.camsMode == '2' ? true : false,
    cardText: `We’ll require holding statement as on <b> ${this.getMonth}</b>`,
    camsMode : 2
    
  },
  {
    title: 'Verify through Bank Statement via OTP ',
    isRecommeded:  this.camsMode == '3' ? true : false,
    cardText: `We’ll require statement duration between <b>${this.dateRange}</b>`,
    camsMode : 3
  }]
    }

  }

  manuallyUpload(){
    clevertapPush('Segment_Activation_MOD', {
      parameter1: 'MOD_SEG_MANUAL',
      parameter2: 'Manual_Income_Proof_Upload_Initiated'
  });
  this.btnLoader = false;
  this.matBottomSheet.open(IncomeProofBottomsheetComponent, {
  data: false
})
  }

  manualActive: boolean = false;
  bankActive: boolean = true;

  cardSelection() {
      this.manualActive = this.manualActive ? false : true;
      this.bankActive = this.bankActive ? false : true;
  }

  formatDate(date: Date): string {
    const options = { year: 'numeric', month: 'short' } as const;
    return date.toLocaleDateString('en-US', options);
  }
  
    updateDateRange(): void {
      const currentDate = new Date();
      const sixMonthsAgo = new Date();
      // Adjust month and year if necessary
      const currentMonth = currentDate.getMonth();
      if (currentMonth - 6 < 0) {
        sixMonthsAgo.setFullYear(currentDate.getFullYear() - 1);
        sixMonthsAgo.setMonth(12 + (currentMonth - 6));
      } else {
        sixMonthsAgo.setMonth(currentMonth - 6);
      }
      const startDate = this.formatDate(sixMonthsAgo);
      const endDate = this.formatDate(currentDate);
      this.dateRange = `${startDate} to ${endDate}`;
    }

    async cardSubmit(url:string) {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
      // Open as bottom sheet on mobile
      this.matBottomSheet.open(LoaderbotomsheetComponent, { 
        disableClose: true,
        data: {
            url:url
          }
      });
      } else {
      // Open as dialog on desktop/web
        this.dialog.open(LoaderbotomsheetComponent, {
          width: '360px',
          height: '286px',
          panelClass: 'custom-dialog-container',
          disableClose: true,
          data: {
            url:url
          }
        });
      }
    }

  async getVendorURL() {
    this.btnDisable = true;
      const returnUrl =
        window.location.hostname.includes('dev') 
            ? 'http://dev.5paisa.in:4200/derivative/loader'
            : 'https://' + window.location.hostname + '/derivative/loader';   
          //appSource (In UPPER Case) + clientCode + ipAddress + redirectUrl + vendorType
          this.btnLoader = true;
          const checksum = this.UserSession.appSource.toUpperCase() +  this.UserSession.clientCode  + this.UserSession.ip + returnUrl + this.casmMap.get(this.selectcamsMode) + this.utilService.checkSumDate
          sessionStorage.setItem('vendorType',this.casmMap.get(this.selectcamsMode) || '')
          const getVendorURLReq: GetVendorURLReq = {
            appSource:  this.UserSession.appSource,
            ipAddress: this.userSessionService.getUserSessionData().ip,
            checkSumValue: this.utilService.GenerateCheckSum(checksum),
            clientCode: this.userSessionService.getUserSessionData().clientCode,
            redirectUrl: returnUrl,
            userId: this.userSessionService.getUserSessionData().clientCode,
            vendorType :  this.casmMap.get(this.selectcamsMode) || ''
          };
    this.commonService.getVendorURL(getVendorURLReq).subscribe({
      next: (response) => {
       sessionStorage.setItem('sessionId', response.data.sessionId);
      this.cardSubmit(response.data.redirectUrl)
        // window.location.href = response.data.redirectUrl;
    },error : (err)=>{
     this.btnDisable = false;
    },})
}
  
selectCard(index: number, cardDetails: cardDetails) {
  this.selectedCardIndex = index;
  this.selectcamsMode = cardDetails.camsMode.toString();
}
  
 get getMonth() {
const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);

const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', year: 'numeric' };
return yesterday.toLocaleDateString('en-GB', options)


  }
}